<template>
	<DiscoveryTableSingleEdit />
</template>

<script>
import DiscoveryTableSingleEdit from "@/components/DiscoveryTable/DiscoveryTableSingle/DiscoveryTableSingleEdit";

export default {
	name: "DiscoveryPageSingle",
	components: {
		DiscoveryTableSingleEdit
	}
}
</script>

<style scoped>

</style>